import styles from './ReportTypesGrid.module.scss';

import React from 'react';
import Link from 'gatsby-link';
import { Container, Row, Col } from 'reactstrap';
import { ScrollOverPack, TweenOne, FadeUp, FadeIn } from 'src/components/Animations';

export default (props) => (
  <ScrollOverPack {...props}
                  className={props.className}
                  styleName='report-types-grid'>
      <TweenOne key='0' component={Container} {...FadeIn}>
          <div className='h2'>Building a data-driving supply chain?</div>
          <div className='h2 text-blue'>Look no further.</div>
      </TweenOne>
      <TweenOne key='1' component={Container} {...FadeUp}>
          <Row>
              <Col lg='4' md='6' xs='12' styleName='cell'>
                  <div styleName='heading'>Shipment details</div>
                  <div>
                      Pull package-level data for your shipments across all of
                      your carriers, instantly. Never touch a slow, clunky carrier
                      web portal again.
                  </div>
              </Col>
              <Col lg='4' md='6' xs='12' styleName='cell'>
                  <div styleName='heading'>Accessorials</div>
                  <div>
                      See which surcharges and accessorials are costing you the
                      most money, and find new opportunities to save.
                  </div>
              </Col>
              <Col lg='4' md='6' xs='12' styleName='cell'>
                  <div styleName='heading'>Time-in-transit</div>
                  <div>
                      View time-in-transit information across countries, states,
                      and zip code prefixes. Want to know how many shipments are
                      missing their deadlines? No longer a problem.
                  </div>
              </Col>
              <Col lg='4' md='6' xs='12' styleName='cell'>
                  <div styleName='heading'>Unit costs</div>
                  <div>
                      Manage unit costs across zones, service types, and weights
                      over time. Instantly know which lanes are working and which
                      ones are costing you.
                  </div>
              </Col>
              <Col lg='4' md='6' xs='12' styleName='cell'>
                  <div styleName='heading'>Volume</div>
                  <div>
                      Your volumes speak volumes about the health of your
                      business. Pull aggregated volume data by zone, weight,
                      service type, account number, and more.
                  </div>
              </Col>
              <Col lg='4' md='6' xs='12' styleName='cell'>
                  <div styleName='heading'>Audit reports</div>
                  <div>
                      Track refund credits that get applied to your carrier
                      accounts over time. View refunds from both Galleon's
                      audit, as well as your own internal audit operations.
                  </div>
              </Col>
              <Col lg='4' md='6' xs='12' styleName='cell'>
                  <div styleName='heading'>Invoice summaries</div>
                  <div>
                      Get the original, adjusted, and final costs for invoices
                      across all of your carriers. Great for accounting teams.
                  </div>
              </Col>
              <Col lg='4' md='6' xs='12' styleName='cell'>
                  <div styleName='heading'>Scheduled reports</div>
                  <div>
                      Generate any of these reports either weekly or monthly, and
                      have the results emailed to anyone on your team.
                  </div>
              </Col>
              <Col lg='4' md='6' xs='12' styleName='cell'>
                  <div styleName='heading'>And much more</div>
                  <div>
                      We're constantly adding more sophisticated reports. If
                      there's something you'd like to see,
                      just <Link to='/contact'>let us know</Link> and we'll get it
                      added.
                  </div>
              </Col>
          </Row>
      </TweenOne>
  </ScrollOverPack>
);



// WEBPACK FOOTER //
// ./src/components/ReportTypesGrid.js